import React, {useEffect, useState} from 'react';

import {formatNumberToEuropeanStyle, INTERACTION, isEmpty, STEPS_STATUS} from "utils";
import {useActiveItemContext} from "./useActiveItemContext";
import {useActionContext} from "./useActionContext";
import {useModalsContext} from "layouts";
import {useAuthorization} from "hooks";

import BazaarCurrentItemAccordion from "./BazaarCurrentItemAccordion";

const BazaarCurrentItemAccordionBlock = ({interaction, totalOwnedNFT, queryHook}) => {
    const {data, chainId, calculateKompetePrice, handleAuthAndWalletChecks} = useActiveItemContext()
    const {isAuth,accessToken} = useAuthorization();
    const {setCurrentModal} = useModalsContext()
    const {actionDetails} = useActionContext()

    const [total, setTotal] = useState(0)
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const {data: fetchedData, isFetching} = queryHook({
        limit: 5,
        offset: page * 5,
        chain_id: chainId.toString(),
        token_id: data?.details.token_id,
    },{
        skip: !accessToken
    });

    useEffect(() => {
        handleActionDetails()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [actionDetails])

    useEffect(() => {
        processFetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchedData]);

    const processFetchData = () => {
        if (fetchedData) {

            if (isEmpty(fetchedData?.orders)) {
                setHasMore(false);
                return
            }

            const {orders, total} = fetchedData;

            setItems((prevState) => {
                const filteredData = orders.filter(item => !prevState.find(prevItem => item.id === prevItem.id))
                return [...prevState, ...filteredData]
            });

            setHasMore(true);
            setTotal(total)

            if (orders.length < 5) {
                setHasMore(false);
            }
        }
    }

    const handleActionDetails = () => {
        const removalInteractionTypes = [INTERACTION.CANCEL, INTERACTION.CANCEL_OFFER, INTERACTION.CANCEL_LISTING];
        const editInteractionTypes = [INTERACTION.EDIT, INTERACTION.EDIT_OFFER];

        const isMatchingInteractionType = (types) => types.includes(actionDetails.type) && actionDetails.isSuccess;

        if (isMatchingInteractionType(removalInteractionTypes)) {
            setItems(prevItems => prevItems.filter(item => item.id !== actionDetails.data.order_id))
            setTotal(prevTotal => prevTotal - 1)
        }

        if (isMatchingInteractionType(editInteractionTypes)) {
            setItems(prevItems => prevItems.map(item => {
                if (item.id === actionDetails.data?.id) {
                    return {
                        ...item,
                        order: actionDetails.data?.order,
                        signature: actionDetails.data?.signature,
                        price: actionDetails.data?.price?.toString(),
                        expiration_date: actionDetails.data?.deadline,
                    }
                }
                return item
            }))
        }
    }

    const handleListAction = (action, data) => {
        if (!handleAuthAndWalletChecks()) return

        let status;

        if (interaction === INTERACTION.SELL) {
            status = action === INTERACTION.CANCEL ? STEPS_STATUS.CANCEL_LISTING : STEPS_STATUS.EDIT_LISTING;
        } else {
            status = action === INTERACTION.CANCEL ? STEPS_STATUS.CANCEL_OFFER : STEPS_STATUS.EDIT_OFFER;
        }

        setCurrentModal({status, data})
    }

    const handleScrollBottom = () => {
        if (!isFetching && hasMore) {
            setHasMore(false);
            setPage((prevPage) => prevPage + 1);
        }
    }

    return (
        isAuth && !isEmpty(items) &&
        <BazaarCurrentItemAccordion
            hasMore={hasMore}
            type={interaction}
            isLoading={isFetching}
            totalInteracted={total}
            totalItems={totalOwnedNFT}
            actionCallBack={handleListAction}
            onScrollBottom={handleScrollBottom}
            items={items.map((item) => ({...item, usd_price: calculateKompetePrice(item.price)}))}
            currencyRange={`${formatNumberToEuropeanStyle(fetchedData.price_details.min_price)}-${formatNumberToEuropeanStyle(fetchedData.price_details.max_price)}`}
        />
    )
}

export default BazaarCurrentItemAccordionBlock;